import {DateTimeFormatter, ZonedDateTime} from "js-joda";
import {months} from "../../../../util/timeDescription";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
    width: 100px;
    flex-shrink: 0;
    
    .day { ${({newDay}) => newDay ? `font-weight: bold;` : `display: none;`} }
    .date { ${({newDay}) => newDay ? `` : `display: none;`} }
`;

export const ActionTimeHeader = () => {
    return <Container className="t-time-header">Time</Container>;
};

const dayFormat = DateTimeFormatter.ofPattern("dd ");
const yearFormat = DateTimeFormatter.ofPattern(" yyyy");
const timeFormat = DateTimeFormatter.ofPattern("HH:mm");

export const ActionTime = ({activity: {dateTime, day}, newDay}) => {
    const authorDateTime = ZonedDateTime.parse(dateTime);
    const dateString = authorDateTime.format(dayFormat) + months[authorDateTime.monthValue() - 1] + authorDateTime.format(yearFormat);
    const timeString = authorDateTime.format(timeFormat);

    return (
        <Container newDay={newDay}>
            <div className="day t-day">Day {day}</div>
            <div className="date t-date">{dateString}</div>
            <div className="time t-time">{timeString}</div>
        </Container>
    )
};